import { render, staticRenderFns } from "./ProposalTasksView.vue?vue&type=template&id=0be9c6d7&scoped=true&"
import script from "./ProposalTasksView.vue?vue&type=script&lang=js&"
export * from "./ProposalTasksView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalTasksView.vue?vue&type=style&index=0&id=0be9c6d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9c6d7",
  null
  
)

export default component.exports